<template>
  <v-badge
    overlap
    top
    :value="badge"
    :color="badgeColor"
    left
  >
    <template v-slot:badge>
      <v-icon>{{ badge }}</v-icon>
    </template>
    <v-list-item-avatar
      v-if="list"
      tile
      :color="color"
      class="pa-4"
    >
      <v-img
        style="position: absolute; left:0"
        :contain="contain"
        :src="image"
      />
      <v-icon
        v-if="icon"
        :size="size"
      >
        {{ icon }}
      </v-icon>
      <span
        v-else
        style="left: 0; position: absolute; width: 100%;"
      >{{ generateName(name) }}</span>
    </v-list-item-avatar>
    <v-avatar
      v-else
      :size="size"
      tile
      :color="color"
    >
      <v-img
        style="position: absolute;"
        :contain="contain"
        :src="image"
      />
      <v-icon
        v-if="icon"
        :size="size / 1.5"
      >
        {{ icon }}
      </v-icon>
      <span
        v-else
        style="left: 0; position: absolute; width: 100%;"
        :style="{fontSize: size / 2.2 + 'px'}"
      >{{ generateName(name) }}</span>
    </v-avatar>
  </v-badge>
</template>

<script>
  export default {
    name: 'Avatar',
    props: {
      list: {
        type: Boolean
      },
      image: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: 'primary'
      },
      contain: {
        type: Boolean
      },
      badge: {
        type: String,
        default: null,
      },
      badgeColor: {
        type: String,
        default: 'primary'
      },
      size: {
        type: String,
        default: '100'
      }
    },
    methods: {
      generateName (name) {
        if (name) {
          var initials = name.split(' ').map(function (str) { return str ? str[0].toUpperCase() : '' }).join('')
          return initials
        } else {
          return ''
        }
      },
    }
  }
</script>
